import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { useEffect, useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Calendar, User, ArrowRight, Search } from "lucide-react";
import { Link } from "react-router-dom";

const BLOG_POSTS = [
  {
    id: 1,
    title: "Can Spinal Decompression Help a Herniated Disc?",
    excerpt: "Learn how spinal decompression therapy offers a non-surgical solution for herniated discs, sciatica, and chronic back pain.",
    category: "Therapies",
    author: "Dr. Tucker Woods",
    date: "March 15, 2026",
    image: "https://wsrv.nl/?url=https://vibe.filesafe.space/1774569058151009111/assets/2d377a90-a463-4e54-a3e0-3b713a3a163d.png&w=1280&output=webp&q=80",
    slug: "/blog/spinal-decompression"
  },
  {
    id: 2,
    title: "The Science Behind Red Light Therapy: Can It Really Reduce Pain and Inflammation?",
    excerpt: "Red light therapy isn't just a trend. Learn how specific wavelengths of light stimulate cellular energy and accelerate your body's natural healing.",
    category: "Wellness",
    author: "Dr. Lance Potter",
    date: "March 02, 2026",
    image: "https://wsrv.nl/?url=https://vibe.filesafe.space/1774569058151009111/attachments/e3fefda6-4541-41e2-b1b1-3631721c72b4.png&w=1280&output=webp&q=80",
    slug: "/blog/red-light-therapy"
  },
  {
    id: 3,
    title: "5 Signs Your Joint Pain Is Caused by Chronic Inflammation",
    excerpt: "Chronic inflammation is often the hidden culprit behind persistent joint pain. Explore the signs and discover effective, non-invasive therapies for lasting relief.",
    category: "Health Tips",
    author: "Dr. Tucker Woods",
    date: "February 18, 2026",
    image: "https://wsrv.nl/?url=https://vibe.filesafe.space/1774569058151009111/assets/eb18bba4-1336-4842-bf52-f007c2b14460.png&w=1280&output=webp&q=80",
    slug: "/blog/inflammation-joint-pain"
  },
  {
    id: 4,
    title: "Finding Relief from Neuropathy: Can SoftWave TRT Heal Nerve Damage?",
    excerpt: "Struggling with numbness, tingling, or burning pain? Discover how SoftWave Tissue Regeneration Technology offers a powerful solution for nerve damage.",
    category: "Neuropathy",
    author: "Dr. Tucker Woods",
    date: "March 27, 2026",
    image: "https://wsrv.nl/?url=https://softwavetrt.com/wp-content/uploads/2026/02/softwave099-1.png&w=1280&output=webp&q=80",
    slug: "/blog/neuropathy-softwave"
  },
  {
    id: 5,
    title: "Can SoftWave TRT Cure Plantar Fasciitis? A Non-Surgical Solution",
    excerpt: "Struggling with sharp heel pain in the morning? Learn how SoftWave TRT offers a non-invasive, highly effective treatment for Plantar Fasciitis.",
    category: "SoftWave TRT",
    author: "Dr. Tucker Woods",
    date: "April 10, 2026",
    image: "https://wsrv.nl/?url=https://vibe.filesafe.space/1774569058151009111/assets/c8e3792a-6f6f-4202-9477-c8e4235a9e41.png&w=1280&output=webp&q=80",
    slug: "/blog/softwave-plantar-fasciitis"
  },
  {
    id: 6,
    title: "Avoiding Knee Surgery: How SoftWave TRT Helps Osteoarthritis",
    excerpt: "Learn how SoftWave TRT stimulates cartilage repair and reduces knee pain from osteoarthritis without injections or surgery.",
    category: "SoftWave TRT",
    author: "Dr. Lance Potter",
    date: "April 12, 2026",
    image: "https://wsrv.nl/?url=https://vibe.filesafe.space/1774569058151009111/assets/cc67cecd-7d86-42f5-9169-5eab8d35ac71.png&w=1280&output=webp&q=80",
    slug: "/blog/softwave-knee-pain"
  },
  {
    id: 7,
    title: "Healing Rotator Cuff Tears Without Surgery: The SoftWave TRT Approach",
    excerpt: "Struggling with shoulder pain or a rotator cuff injury? Discover how SoftWave TRT accelerates tissue repair and restores mobility.",
    category: "SoftWave TRT",
    author: "Dr. Tucker Woods",
    date: "April 15, 2026",
    image: "https://wsrv.nl/?url=https://vibe.filesafe.space/1774569058151009111/assets/52c3a3ee-ee80-4859-b6ef-67d0d737e7ae.png&w=1280&output=webp&q=80",
    slug: "/blog/softwave-shoulder-pain"
  },
  {
    id: 8,
    title: "Stop the Ache: Treating Tennis Elbow with SoftWave TRT",
    excerpt: "Tennis elbow isn't just for athletes. Learn how SoftWave TRT heals damaged tendons in your elbow quickly and non-invasively.",
    category: "SoftWave TRT",
    author: "Dr. Lance Potter",
    date: "April 20, 2026",
    image: "https://wsrv.nl/?url=https://vibe.filesafe.space/1774569058151009111/assets/dfc1de8f-ccbf-48ab-93a2-24fab35af161.png&w=1280&output=webp&q=80",
    slug: "/blog/softwave-tennis-elbow"
  },
  {
    id: 9,
    title: "Breaking the Cycle of Chronic Lower Back Pain with SoftWave TRT",
    excerpt: "Discover how SoftWave TRT reduces muscle spasms, lowers inflammation, and accelerates healing for chronic lower back pain.",
    category: "SoftWave TRT",
    author: "Dr. Tucker Woods",
    date: "April 25, 2026",
    image: "https://wsrv.nl/?url=https://vibe.filesafe.space/1774569058151009111/assets/53b5ed68-4988-48e6-a6ba-fe0adb85fe19.png&w=1280&output=webp&q=80",
    slug: "/blog/softwave-back-pain"
  },
  {
    id: 10,
    title: "Sciatica Relief: How Spinal Decompression Targets the Root Cause",
    excerpt: "Struggling with shooting leg pain and sciatica? Learn how DRX9000 Spinal Decompression treats the root cause without surgery.",
    category: "Spinal Decompression",
    author: "Dr. Tucker Woods",
    date: "May 02, 2026",
    image: "https://wsrv.nl/?url=https://vibe.filesafe.space/1774569058151009111/assets/34920f7b-9e8d-4a9f-aacf-4ee0318ec5c7.png&w=1280&output=webp&q=80",
    slug: "/blog/decompression-sciatica"
  },
  {
    id: 11,
    title: "Managing Degenerative Disc Disease Without Surgery",
    excerpt: "Diagnosed with Degenerative Disc Disease? Learn how DRX9000 Spinal Decompression helps rehydrate discs and relieve chronic back pain.",
    category: "Spinal Decompression",
    author: "Dr. Lance Potter",
    date: "May 05, 2026",
    image: "https://wsrv.nl/?url=https://vibe.filesafe.space/1774569058151009111/assets/a11b1b5a-9ef6-4b9c-8059-e024e73d7499.jpg&w=1280&output=webp&q=80",
    slug: "/blog/decompression-degenerative-disc-disease"
  },
  {
    id: 12,
    title: "Got a Pinched Nerve? Why Spinal Decompression Works Faster Than Rest",
    excerpt: "A pinched nerve in the lower back can cause excruciating pain. Discover why DRX9000 Spinal Decompression is the fastest way to find relief.",
    category: "Spinal Decompression",
    author: "Dr. Tucker Woods",
    date: "May 08, 2026",
    image: "https://wsrv.nl/?url=https://vibe.filesafe.space/1774569058151009111/assets/2d377a90-a463-4e54-a3e0-3b713a3a163d.png&w=1280&output=webp&q=80",
    slug: "/blog/decompression-pinched-nerve"
  },
  {
    id: 13,
    title: "Chronic Neck Pain and Arm Numbness? Exploring Cervical Decompression",
    excerpt: "Experiencing chronic neck pain or numbness traveling down your arm? Learn how cervical spinal decompression offers non-surgical relief.",
    category: "Spinal Decompression",
    author: "Dr. Lance Potter",
    date: "May 12, 2026",
    image: "https://wsrv.nl/?url=https://vibe.filesafe.space/1774569058151009111/assets/87897a3a-ab5c-44e3-9c3a-7899d6a614b2.jpg&w=1280&output=webp&q=80",
    slug: "/blog/decompression-neck-pain"
  },
  {
    id: 14,
    title: "Failed Back Surgery? Why Spinal Decompression Offers New Hope",
    excerpt: "Still in pain after spinal surgery? Learn how DRX9000 Spinal Decompression offers a safe, non-invasive solution for Failed Back Surgery Syndrome.",
    category: "Spinal Decompression",
    author: "Dr. Tucker Woods",
    date: "May 18, 2026",
    image: "https://wsrv.nl/?url=https://vibe.filesafe.space/1774569058151009111/assets/58a71ded-c984-472e-94c4-1fe1ddbfe36c.jpg&w=1280&output=webp&q=80",
    slug: "/blog/decompression-failed-back-surgery"
  },
  {
    id: 15,
    title: "How Red Light Therapy Accelerates Muscle Recovery",
    excerpt: "Discover how Red Light Therapy speeds up muscle recovery, reduces soreness, and improves athletic performance for active individuals.",
    category: "Red Light Therapy",
    author: "Dr. Lance Potter",
    date: "May 20, 2026",
    image: "https://wsrv.nl/?url=https://vibe.filesafe.space/1774569058151009111/assets/2e8da277-2ec1-4ef5-8f60-f2212061c013.png&w=1280&output=webp&q=80",
    slug: "/blog/red-light-muscle-recovery"
  },
  {
    id: 16,
    title: "Red Light Therapy for Body Contouring: How It Helps Shrink Fat Cells",
    excerpt: "Learn how Red Light Therapy safely targets stubborn fat cells and aids in body contouring without surgery or downtime.",
    category: "Red Light Therapy",
    author: "Dr. Tucker Woods",
    date: "May 25, 2026",
    image: "https://wsrv.nl/?url=https://vibe.filesafe.space/1774569058151009111/assets/0a388567-74f9-4601-bb40-b34c0a3a94b7.png&w=1280&output=webp&q=80",
    slug: "/blog/red-light-body-contouring"
  },
  {
    id: 17,
    title: "Rejuvenating Your Skin: The Anti-Aging Benefits of Red Light Therapy",
    excerpt: "Discover how Red Light Therapy stimulates collagen production, reduces wrinkles, and improves overall skin health naturally.",
    category: "Red Light Therapy",
    author: "Dr. Lance Potter",
    date: "June 02, 2026",
    image: "https://wsrv.nl/?url=https://vibe.filesafe.space/1774569058151009111/assets/cf0ceb09-514d-424a-bd29-c804020d9622.png&w=1280&output=webp&q=80",
    slug: "/blog/red-light-skin-rejuvenation"
  },
  {
    id: 18,
    title: "Managing Chronic Joint Pain and Arthritis with Red Light Therapy",
    excerpt: "Learn how deep-penetrating Red Light Therapy reduces inflammation and relieves chronic joint pain and arthritis symptoms.",
    category: "Red Light Therapy",
    author: "Dr. Tucker Woods",
    date: "June 08, 2026",
    image: "https://wsrv.nl/?url=https://vibe.filesafe.space/1774569058151009111/assets/5a003c0d-92fe-47a9-97d7-88e994daf1e0.png&w=1280&output=webp&q=80",
    slug: "/blog/red-light-joint-pain"
  },
  {
    id: 19,
    title: "Fighting Fatigue: How Red Light Therapy Boosts Cellular Energy",
    excerpt: "Feeling constantly drained? Discover how full-body Red Light Therapy stimulates ATP production to boost your energy levels naturally.",
    category: "Red Light Therapy",
    author: "Dr. Lance Potter",
    date: "June 15, 2026",
    image: "https://wsrv.nl/?url=https://vibe.filesafe.space/1774569058151009111/assets/00a765ef-ebdd-4583-b989-f4c2f87e74e4.png&w=1280&output=webp&q=80",
    slug: "/blog/red-light-cellular-energy"
  },
  {
    id: 20,
    title: "Why Doctor-Supervised Weight Loss Works Better",
    excerpt: "Struggling to lose weight on your own? Discover why the doctor-supervised ChiroThin program is safer and more effective.",
    category: "ChiroThin Weight Loss",
    author: "Dr. Tucker Woods",
    date: "June 20, 2026",
    image: "https://wsrv.nl/?url=https://vibe.filesafe.space/1774569058151009111/assets/ad300886-b785-4a12-b444-d8cd3efdd8b2.png&w=1280&output=webp&q=80",
    slug: "/blog/chirothin-doctor-supervised"
  },
  {
    id: 21,
    title: "Why Fad Diets Fail (And What ChiroThin Does Differently)",
    excerpt: "Tired of yo-yo dieting? Discover why extreme fad diets fail and how the ChiroThin program promotes sustainable weight loss.",
    category: "ChiroThin Weight Loss",
    author: "Dr. Lance Potter",
    date: "June 25, 2026",
    image: "https://wsrv.nl/?url=https://vibe.filesafe.space/1774569058151009111/assets/eedc8b0b-29c9-4e8b-81ca-8de7d60dc663.png&w=1280&output=webp&q=80",
    slug: "/blog/chirothin-fad-diets"
  },
  {
    id: 22,
    title: "The Hidden Link Between Weight Loss and Joint Pain Relief",
    excerpt: "Discover how losing weight with the ChiroThin program can drastically reduce knee and back pain, improving your mobility.",
    category: "ChiroThin Weight Loss",
    author: "Dr. Tucker Woods",
    date: "July 02, 2026",
    image: "https://wsrv.nl/?url=https://vibe.filesafe.space/1774569058151009111/assets/d87d12de-3bd0-4a0f-befb-74a3eb1ba6d3.png&w=1280&output=webp&q=80",
    slug: "/blog/chirothin-joint-pain"
  },
  {
    id: 23,
    title: "Understanding the ChiroThin Dietary Guidelines: Real Food, Real Results",
    excerpt: "Curious about what you actually eat on the ChiroThin program? Learn how real, anti-inflammatory foods drive sustainable weight loss.",
    category: "ChiroThin Weight Loss",
    author: "Dr. Lance Potter",
    date: "July 10, 2026",
    image: "https://wsrv.nl/?url=https://vibe.filesafe.space/1774569058151009111/assets/731c23db-1b39-4bf4-a604-5dd17c931766.png&w=1280&output=webp&q=80",
    slug: "/blog/chirothin-dietary-guidelines"
  },
  {
    id: 24,
    title: "Resetting Your Metabolism: How ChiroThin Helps Keep the Weight Off",
    excerpt: "Learn how the doctor-supervised ChiroThin program helps reset your metabolic set-point to prevent rebound weight gain.",
    category: "ChiroThin Weight Loss",
    author: "Dr. Tucker Woods",
    date: "July 15, 2026",
    image: "https://wsrv.nl/?url=https://vibe.filesafe.space/1774569058151009111/assets/c89eb6c1-abc7-4bea-b271-c7abc751f49c.png&w=1280&output=webp&q=80",
    slug: "/blog/chirothin-reset-metabolism"
  }
];

import { SEOHead } from "@/components/SEOHead";

export default function Blog() {
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [searchQuery, setSearchQuery] = useState("");
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const categories = ["All", ...Array.from(new Set(BLOG_POSTS.map(post => post.category)))];

  const filteredPosts = BLOG_POSTS.filter(post => {
    const matchesCategory = selectedCategory === "All" || post.category === selectedCategory;
    const matchesSearch = post.title.toLowerCase().includes(searchQuery.toLowerCase()) || 
                          post.excerpt.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  return (
    <div className="min-h-screen bg-background font-sans text-foreground flex flex-col">
      <SEOHead 
        title="Blog | Woods Spine & Wellness | Longview TX"
        description="Stay up to date with the latest news, health tips, and wellness advice from the team at Woods Spine & Wellness."
        ogImage="https://vibe.filesafe.space/1774569058151009111/assets/58600117-1663-43e4-98fd-7b421e93ecd3.png"
        canonical="https://woodsspine.com/blog"
      />
      <Navbar />
      <main className="flex-grow flex flex-col">
        {/* Hero Section */}
        <section className="relative pt-20 pb-20 lg:pt-28 lg:pb-28 overflow-hidden bg-primary text-primary-foreground">
          <div className="absolute inset-0 z-0">
            <div className="absolute inset-0 bg-primary/90"></div>
          </div>
          <div className="container relative z-10 mx-auto px-4 text-center">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-4">
              Our <span className="text-accent">Blog</span>
            </h1>
            <p className="text-lg md:text-xl max-w-2xl mx-auto text-primary-foreground/90">
              Stay up to date with the latest news, health tips, and wellness advice from the team at Woods Spine & Wellness.
            </p>
          </div>
        </section>

        {/* Blog Grid Section */}
        <section className="py-20 bg-secondary/30 flex-grow">
          <div className="container mx-auto px-4">
            
            {/* Search Bar */}
            <div className="max-w-xl mx-auto mb-8 relative">
              <Search className="absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 text-muted-foreground" />
              <Input
                type="text"
                placeholder="Search articles by title or keyword..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="pl-12 h-12 text-base rounded-full bg-background border-primary/20 focus-visible:ring-primary shadow-sm"
              />
            </div>

            {/* Category Filter */}
            <div className="flex flex-wrap gap-2 justify-center mb-12">
              {categories.map((category) => (
                <Button
                  key={category}
                  variant={selectedCategory === category ? "default" : "outline"}
                  onClick={() => setSelectedCategory(category)}
                  className={selectedCategory === category ? "bg-primary text-primary-foreground hover:bg-primary/90" : "bg-background"}
                >
                  {category}
                </Button>
              ))}
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {filteredPosts.length > 0 ? (
                filteredPosts.map((post) => (
                  <Link to={post.slug} key={post.id} className="block group h-full">
                    <Card className="overflow-hidden border-0 shadow-lg flex flex-col h-full transition-shadow hover:shadow-xl">
                      <div className="relative h-60 overflow-hidden bg-muted">
                        <img 
                          src={post.image} 
                          alt={post.title}
                          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                          loading="lazy"
                        />
                        <div className="absolute top-4 left-4">
                          <Badge className="bg-accent text-white hover:bg-accent/90 border-0 shadow-sm">
                            {post.category}
                          </Badge>
                        </div>
                      </div>
                      <CardHeader className="flex-grow">
                        <div className="flex items-center text-xs text-muted-foreground mb-3 space-x-4">
                          <span className="flex items-center">
                            <Calendar className="w-3 h-3 mr-1" />
                            {post.date}
                          </span>
                          <span className="flex items-center">
                            <User className="w-3 h-3 mr-1" />
                            {post.author}
                          </span>
                        </div>
                        <CardTitle className="text-xl leading-tight mb-3 group-hover:text-primary transition-colors">
                          {post.title}
                        </CardTitle>
                        <p className="text-muted-foreground text-sm line-clamp-3">
                          {post.excerpt}
                        </p>
                      </CardHeader>
                      <CardContent className="pt-0 mt-auto">
                        <div className="flex items-center text-sm font-semibold text-accent group-hover:text-accent/80 transition-colors">
                          Read Article <span className="sr-only">about {post.title}</span> <ArrowRight className="w-4 h-4 ml-1" />
                        </div>
                      </CardContent>
                    </Card>
                  </Link>
                ))
              ) : (
                <div className="col-span-full text-center py-16 bg-background rounded-2xl border border-border/50 shadow-sm">
                  <div className="inline-flex h-16 w-16 items-center justify-center rounded-full bg-muted mb-4">
                    <Search className="h-8 w-8 text-muted-foreground" />
                  </div>
                  <h3 className="text-2xl font-bold text-primary mb-2">No articles found</h3>
                  <p className="text-muted-foreground max-w-md mx-auto mb-6">
                    We couldn't find any articles matching your search query or selected category.
                  </p>
                  <Button 
                    variant="outline" 
                    onClick={() => { setSearchQuery(""); setSelectedCategory("All"); }}
                    className="border-primary text-primary hover:bg-primary hover:text-primary-foreground"
                  >
                    Clear Filters & Search
                  </Button>
                </div>
              )}
            </div>
            
            <div className="mt-16 text-center">
              <Button variant="outline" size="lg" className="border-primary text-primary hover:bg-primary hover:text-primary-foreground">
                Load More Posts
              </Button>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
